var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaigns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outline Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.247,8.213a.941.941,0,0,0,.25.034.965.965,0,0,0,.931-.716l1.152-4.3a.964.964,0,1,0-1.863-.5l-1.152,4.3A.963.963,0,0,0,19.247,8.213Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.942,9.96a.966.966,0,0,0,1.365,0l3.635-3.638a.965.965,0,0,0-1.365-1.364L20.942,8.6A.967.967,0,0,0,20.942,9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.854,10a.962.962,0,0,0-1.181-.681l-4.3,1.155a.965.965,0,0,0,.25,1.9.934.934,0,0,0,.25-.033l4.3-1.155A.964.964,0,0,0,28.854,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.576,6.981,3.138,23.747a3.405,3.405,0,0,0,1.22,2.928A3.37,3.37,0,0,0,6.72,27.833a1.528,1.528,0,0,0,.444-.055L9.3,26.7l3.045,3.045a.815.815,0,0,0,1.154,0l.08-.08a.815.815,0,0,0,0-1.154l-2.638-2.639,12.975-6.544C21.216,10.512,11.576,6.981,11.576,6.981ZM6.62,25.891a1.9,1.9,0,0,1-.9-.58,2.19,2.19,0,0,1-.664-1.09L12.468,9.5c2.39,1.213,6.91,4.041,9.037,8.886Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/campaigns.dacf354e0670495110263de24c60aac4.svg";
export { ForwardRef as ReactComponent };